<template>
  <div
    class="content pr-2 supportEmail"
    style="cursor:pointer"
  >
    <div class="columns">
      <div class="column is-12 pr-0">
        <div
          class="box mb-0 is-radiusless is-paddingless"
          :class="{'is-handled': email.handled_by}"
          @click="expandEmail()"
        >
          <div
            class="border-bottom support-email-header columns is-mobile space-between relative align-center mb-0"
            style="justify-content: space-between; align-items: center"
          >
            <div class="column is-3-desktop is-4-touch player-info">
              <div
                class="is-flex flex-row align-center"
                style="border-right:1px solid #D3D3D3"
              >
                <img
                  v-if="email.memberphoto"
                  :src="email.memberphoto"
                  class="img-circle mr-4 is-hidden-touch"
                >
                <img
                  v-if="!email.memberphoto"
                  src="/images/profile.png"
                  class="img-circle mr-4 is-hidden-touch"
                >
                <div>
                  <router-link
                    :to="{path: `/players/${email.player_ahlid}`}"
                    class="mr-1"
                  >
                    {{ email.player_name }}
                  </router-link>
                  <small class="has-text-dark mr-1 is-block">{{ email.player_ahlid }}</small>
                </div>
              </div>
            </div>
            <div class="column is-6-desktop is-8-touch subject">
              {{ email.subject }}
            </div>
            <div class="column is-3-desktop is-hidden-touch extra-info support-email-dropdown">
              <div class="column is-10 p-1">
                <div
                  class="text-center"
                  style="font-size:0.7rem"
                >
                  <span class="is-hidden-touch">Received:&nbsp;</span>{{ email.received_date }}
                </div>
              </div>
              <div class="column is-10 p-1">
                <div
                  v-if="email.handled_by"
                  class="box is-hidden-touch"
                  style="padding:5px;font-size:0.6rem; background-color: #4267b2; color: #FFF"
                >
                  <div class="text-center">
                    Handled: {{ email.handled_by }}
                  </div>
                </div>
              </div>
              <div class="column is-10 p-1">
                <div
                  v-if="email.category"
                  class="box mb-0 is-hidden-touch"
                  style="padding:5px;font-size:0.6rem; background-color: #F8F8F8; color: #535353"
                >
                  <strong style="color:#535353">
                    <div class="text-center">Category: {{ email.category }}</div>
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <div class="is-hidden-desktop">
            <div class="mobile-received-date-container">
              <div
                class="text-center mobile-received-date"
                style="font-size:0.7rem"
              >
                Received:&nbsp;{{ email.received_date }}
              </div>
            </div>
          </div>
          <div
            v-if="isExpanded"
            class="conversations"
            style="padding-bottom:20px !important"
          >
            <div
              v-if="loading"
              class="spinner-loader"
            >
              <sync-loader />
              <p>Loading ...</p>
            </div>
            <email-conversation
              v-for="conversation in email.conversations"
              :key="conversation.id"
              :conversation="conversation"
              @handle="handle"
              @replyTo="replyTo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import EmailConversation from './EmailConversation.vue'

  export default {
    name: 'SupportEmail',
    components: {
      EmailConversation,
    },
    props: ['token', 'user', 'email'],
    data() {
      return {
        isExpanded: false,
        edit: false,
        loading: true,
      }
    },
    computed: {
      chunkedEmails() {
        return this.emails.slice(0, 50)
      }
    },
    watch: {},
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
    },
    methods: {
      handle(convObj) {
        this.$emit('handle', {'conv_id': convObj.conv_id, 'reply_to': convObj.reply_to, 'email_id': this.email.id})
      },
      replyTo(convObj) {
        this.$emit('replyTo', {'conv_id': convObj.conv_id, 'reply_to': convObj.reply_to, 'email_id': this.email.id})
      },
      expandEmail() {
        this.email.conversations = this.email.conversations || []

        if (this.email.conversations.length === 0) {
          this.getSupportEmails()
          this.isExpanded = !this.isExpanded
        } else {
          this.isExpanded = !this.isExpanded
        }
      },
      getSupportEmails(page) {
        this.loading = true
        this.$axios({
          method: 'POST',
          url: `admin/supportemails/getconversations/` + this.email.id,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
          }
        })
          .then((res) => {
            if (!res.data.length) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: 'No conversations found'
                })
            } else if (res.data.error) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
            }
            this.email.conversations = res.data
            this.loading = false
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
            this.loading = false
          })
      }
    }
  }
</script>
